// START_MODULE pages_main_sections_news_components_newsitem_newsitem_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import ArrowRight from 'components/atoms/icons/ArrowRight';
import { LinkRouter } from 'components/atoms/link/Link';

import { mainRepository } from 'domain/repositories/MainRepository';
import { INews } from 'domain/entities/INews';

import { route } from 'routes/route';

import { getDate } from 'utils/date/getDate';

interface NewsItemProps {
  news: INews;
}

const NewsItem: React.FC<NewsItemProps> = ({ news }) => {
  const [imageSrc, setImageSrc] = useState<string>('');

  useEffect(() => {
    mainRepository.getImageFile(news.imageHeaderId)
      .then((blob) => URL.createObjectURL(blob))
      .then((src) => setImageSrc(src));
  }, [news.imageHeaderId]);

  return (
    <NewsItemContainer>
      <NewsImage src={imageSrc} />
      <LinkRouter to={route.newsDetails(news.id)} $underline={false}>
        <NewsHeader>{news.header}</NewsHeader>
      </LinkRouter>

      <NewsTest className="formatted-text" dangerouslySetInnerHTML={{ __html: news.content }} />
      <LinkContainer>
        <NewsSubtext>{getDate(news.dateAdded)}</NewsSubtext>
        <LinkRouter to={`/news/${news.id}`}>
          Подробнее
          <ArrowRight />
        </LinkRouter>
      </LinkContainer>
    </NewsItemContainer>
  );
};

const NewsItemContainer = styled.div`
  width: 240px;

  margin-bottom: 40px;
`;

const NewsImage = styled.img`
  width: 100%;
  height: 130px;
  object-fit: cover;
  object-position: center;
  margin-bottom: 4px;

  cursor: pointer;
`;

const NewsHeader = styled.h6`
  font-size: 1rem;
  margin-bottom: 8px;
`;

export const NewsSubtext = styled.p`
  font-size: 0.9rem;
  color: #a7a7a7;
`;

const NewsTest = styled.p`
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;

  margin-bottom: 4px;
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
`;

export default NewsItem;

// END_MODULE pages_main_sections_news_components_newsitem_newsitem_tsx
